import React from "react";

const CvIcon = () => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.063 5.813l-4.375-4.375a.567.567 0 00-.438-.188H5c-.688 0-1.25.563-1.25 1.25v15c0 .688.563 1.25 1.25 1.25h10c.688 0 1.25-.563 1.25-1.25V6.25a.567.567 0 00-.188-.438zM11.25 2.75l3.5 3.5h-3.5v-3.5zM15 17.5H5v-15h5v3.75c0 .688.563 1.25 1.25 1.25H15v10z" fill="#96CEF6" />
    <path d="M6.25 13.75h7.5V15h-7.5v-1.25zm0-3.75h7.5v1.25h-7.5V10z" fill="#96CEF6" />
  </svg>
);

export default CvIcon;
